import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SignatureBox from 'components/SignatureBox';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../reducers';

class CustomerSignature extends Resetter(Validator(React.Component)) {
  state = {
    customerSignature: this.props.customerSignature || '',
    errors: {},
    clearSignature: 0,
  };

  static VALIDATIONS = {
    customerSignature: true,
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    this.props.updateFormData({
      customerSignature: this.state.customerSignature,
      tab: 3,
    });
  }

  handlePrevious = () => {
    this.props.updateFormData({
      customerSignature: this.state.customerSignature,
      tab: 1,
    });
  }

  handleSignatureChange = (data) => {
    this.setState({ customerSignature: data });
  }

  handleClear = () => {
    this.setState({
      customerSignature: '',
      clearSignature: this.props.customerSignature ? this.state.clearSignature : Date.now(),
    });
    this.props.updateFormData({ customerSignature: '' });
  }

  render() {
    const { errors, clearSignature } = this.state;

    return (
      <div>
        <h6 className={S.signatureTitle}>Part 2 - Customer Signature</h6>
        <SignatureBox
          required
          value={this.props.customerSignature}
          label="Sign Customer's Name *"
          errors={errors.customerSignature}
          clearTimestamp={clearSignature}
          onEnd={this.handleSignatureChange}
          onClear={this.handleClear}
        />
        <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
        <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
      </div>
    );
  }
}

CustomerSignature.propTypes = {
  copyPhase: PropTypes.func,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    customerSignature: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(CustomerSignature);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/customer_signature.jsx